import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import TrustSection from "./components/TrustSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import ArticlePreviews from "./components/ArticlePreviews";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        {/* Organization Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "CSSBuy Sheet",
              "url": "https://cssbuyspreadsheets.lat/",
              "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png",
              "description": "A maior coleção de links CSSBuy em português. Tênis, roupas, Yupoo e guias completos.",
              "foundingDate": "2026",
              "areaServed": {
                "@type": "Country",
                "name": "Brasil"
              },
              "sameAs": []
            }),
          }}
        />

        {/* Breadcrumb Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "CSSBuy Spreadsheet",
                  "item": "https://cssbuyspreadsheets.lat/"
                }
              ]
            }),
          }}
        />

        {/* WebSite Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebSite",
              "name": "CSSBuy Spreadsheet",
              "url": "https://cssbuyspreadsheets.lat/",
              "description": "A maior coleção de links CSSBuy em português. Tênis, roupas, Yupoo e guias completos. Atualizado diariamente.",
              "inLanguage": "pt-BR",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "https://cssbuyspreadsheets.lat/search?q={search_term_string}",
                "query-input": "required name=search_term_string"
              }
            }),
          }}
        />

        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <TrustSection />
        <ArticlePreviews />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}